import { DropdownService, IDropdownData } from '@captiveaire/advanceddropdown';

import { Injectable } from '@angular/core';
import { ILocationAreaSummarySearchCriteria, IModuleSummarySearchCriteria } from '@caslink/common-client';
import { AppContextService } from '@caslink/common-client/ng-app/appContext/AppContextService';
import { CustomerService } from '@caslink/common-client/ng-app/customer/CustomerService';
import { LocationSummaryService } from '@caslink/common-client/ng-app/locationSummary/LocationSummaryService';
import { ModuleSummaryService } from '@caslink/common-client/ng-app/moduleSummary/ModuleSummaryService';
import { IDeviceStatusListSearchCriteria } from '../models/device-status-list-search-criteria.interface';
import { DeviceStatusService } from './device-status.service';
import { ReportTemplateService } from './report-template.service';
import { SensorCategoryTypeService } from './sensor-category-type.service';

@Injectable({
    providedIn: 'root'
})
export class DeviceStatusFiltersHandler {
    public locations: IDropdownData;
    public modules: IDropdownData;
    public categories: IDropdownData;
    public reportTemplates: IDropdownData;
    public customers: IDropdownData;

    public showCustomerDropdown: boolean;
    public showIsCertifiedFilter: boolean = false;
    public showIsAirQualityExcellenceFilter: boolean = false;

    public query: IDeviceStatusListSearchCriteria;
    public search: () => void;

    constructor(
        public appContextService: AppContextService,
        public deviceStatusService: DeviceStatusService,
        public dropdownService: DropdownService,
        public moduleSummaryService: ModuleSummaryService,
        public locationSummaryService: LocationSummaryService,
        public sensorCategoryTypeService: SensorCategoryTypeService,
        public reportTemplateService: ReportTemplateService,
        public customerService: CustomerService
    ) { }

    public init(query: IDeviceStatusListSearchCriteria, search: () => void) {
        this.query = query;
        this.search = search;

        this.locationSummaryService.getCanManageIsCertified().then(result => {
            this.showIsCertifiedFilter = result;
        });

        this.locationSummaryService.getCanManageIsAirQualityExcellence().then(result => {
            this.showIsAirQualityExcellenceFilter = result;
        });
    }

    public certifiedHandler($event) {
        this.query.isCertified = $event.value;
        this.customerHandler();
    }

    public airQualityExcellenceHandler($event) {
        this.query.isAirQualityExcellence = $event.value;
        this.customerHandler();
    }

    public customerHandler() {
        if (this.query.customerId !== null) {
            this.query.locationId = this.locations.deselectItem();
            this.query.moduleId = this.modules.deselectItem();
        }

        (this.locations.query as ILocationAreaSummarySearchCriteria).customerId = this.query.customerId;
        (this.locations.query as ILocationAreaSummarySearchCriteria).isCertified = this.query.isCertified;
        (this.locations.query as ILocationAreaSummarySearchCriteria).isAirQualityExcellence = this.query.isAirQualityExcellence;
        (this.modules.query as IModuleSummarySearchCriteria).customerId = this.query.customerId;

        this.locations.search();
        this.modules.search();
        this.search();
    }

    public locationHandler() {
        if (this.query.locationId !== null) {
            this.query.moduleId = this.modules.deselectItem();
        }
        (this.modules.query as IModuleSummarySearchCriteria).locationId = this.query.locationId;
        this.modules.search();
        this.search();
    }

    public initDropdowns(
        wizardView: boolean,
        hideFields: boolean) {
        // In wizard view all dropdowns are hidden so no need to init them
        if (wizardView) {
            return;
        }
        if (!hideFields) {
            const locId = this.query.locationId ? this.query.locationId : null;

            this.locations = this.locationSummaryService.prepareDropdown(locId);

            const moduleId = this.getModuleId();

            this.modules = this.moduleSummaryService.prepareDropdown(moduleId);

            this.customerService.getCanFilterByCustomer().then(canFilterByCustomer => {
                this.showCustomerDropdown = canFilterByCustomer;
                if (this.showCustomerDropdown) {
                    this.customers = this.customerService.prepareDropdown(null);
                }
            });

            (this.modules.query as IModuleSummarySearchCriteria).locationId = this.query.locationId;
        }

        this.categories = this.dropdownService.prepareDropdown('Device Type',
            'type',
            this.sensorCategoryTypeService,
            this.query.hardwareCategoryId);

        this.reportTemplates = this.dropdownService.prepareDropdown('Report Templates',
            'displayName',
            this.reportTemplateService,
            this.query.reportTemplateId ? this.query.reportTemplateId.toString() : null);
    }

    private getModuleId(): number {
        if (this.query.$cached) {
            return this.query.moduleId;
        }

        if (!this.query.moduleId) {
            this.query.moduleId = null;
        }

        if (!this.query.moduleId && !this.query.locationId && !this.query.jobNumber && this.appContextService.isModuleLoaded) {
            this.query.moduleId = this.appContextService.loadedModuleId;
        }
        return this.query.moduleId;
    }
}
